import { graphql } from 'react-relay';

export const publicationsPageFragment = graphql`
  fragment PublicationsPage_page on PublicationsPage {
    publicationsList {
      title
      yearLabel
      filterButtonText
      filterButtonTextExpanded
      noResultsText
      variousFundsText
      liveFilter {
        ...LiveFilter_liveFilter
      }
      detailFilter {
        ...DetailFilter_detailFilter
      }
      documents {
        id
        archiveName
        mimeType
        fileDate
        docTypeName
        documentType
        documentTitle
        size
        fileName
        deeplinkCode
        url
        fundName
        isins
      }
    }
    breadcrumbs {
      ...Breadcrumb_data
    }
    path
    id
  }
`;
